import React from 'react'
import DialogBox from '../../../../../constants/DialogBox';
import { Grid } from '@mui/material';
import { EndBaseLine } from '../../../../../constants/AppSpace';
import { Button } from '../../../../../constants/Button';
import InputTextBox from '../../../../../constants/InputTextBox';
import { useFormik } from 'formik';
import NepaliInputBox from '../../../../../constants/NepaliInputBox';
import { handleChangeDate, handleChangePhone, handleNepaliInputChange, handleSelectBox } from '../../../../../helpers/handleChange';
import { MdOutlinePhone } from 'react-icons/md';
import { CiCalendarDate } from 'react-icons/ci';
import SelectInputBox from '../../../../../constants/SelectInputBox';
import { GenderOptions, YesNoOptions } from '../../../../../constants/Options';
import FileTextBox from '../../../../../constants/FileTextBox';
import { putDataToTheServer } from '../../../../../helpers/api';
import AppURL from '../../../../../constants/AppURL';
import { ToastSuccess } from '../../../../../constants/Toast';
import DefaultSelectInputBox from '../../../../../constants/DefaultSelectBox';
interface StaffEditProps {
    dialogOpen: boolean;
    setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
    currentItem: any;
    handleFormSuccess: () => void;

}
const PayrollStaffEditView: React.FC<StaffEditProps> = ({ dialogOpen, currentItem, handleFormSuccess, setDialogOpen }) => {
    const initialValues = {
        mem_name: currentItem?.mem_name || "",
        mem_name_nep: currentItem?.mem_name_nep || "",
        remarks: currentItem?.remarks || "",
        add_nep: currentItem?.add_nep || "",
        add_eng: currentItem?.add_eng || "",
        status: currentItem?.status ==="2"?"0":"1",
        ward_no: currentItem?.ward_no || "",
        sms_mob_no: currentItem?.sms_mob_no || "",
        dob: currentItem?.dob || "",
        ctiz_no: currentItem?.ctiz_no || "",
        gender: currentItem?.gender || "",
        father_name: currentItem?.father_name || "",
        father_name_nep: currentItem?.father_name_nep || "",
        active: '1',
        date_of_joining: currentItem?.date_of_joining || "",
        date_of_leaving: currentItem?.date_of_leaving || "",
        shift: currentItem?.shift || "",
        bank_holder_name: currentItem?.bank_holder_name || "",
        acc_number: currentItem?.acc_number || "",
        bank_name: currentItem?.bank_name || "",
        branch_name: currentItem?.branch_name || "",
        bank_code: currentItem?.bank_code || "",
        // designation: currentItem?.designation || "",
        initial_salary: currentItem?.initial_salary || "",
        grade_count: currentItem?.grade_count || "",
        grade_amt: currentItem?.grade_amt || "",
        allowance: currentItem?.allowance || "",
        tax_amount: currentItem?.tax_amount || "",
        pr_status: currentItem?.pr_status || "",
        pf_amount: currentItem?.pf_amount || "",
        pf_thap_amt: currentItem?.pf_thap_amt || "",
        ss_tax: currentItem?.ss_tax || "",
        insurance: currentItem?.insurance || "",
        ss_found: currentItem?.ss_found || "",
        qualification: currentItem?.qualification || "",
        training: currentItem?.training || "",
        lang: currentItem?.lang || "",
      };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: districtValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
              const value = (values as Record<string, any>)[key];
              if (value !== undefined && value !== null && value !== "") {
                formData.append(key, value);
              }
              
            });
            try {
                await putDataToTheServer(AppURL.PayrollURL + 'payroll/staff/retreive/update/view/' + currentItem.member_sn, formData).then((res) => {
                    ToastSuccess({ message: res?.message });
                    handleFormSuccess();
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <DialogBox open={dialogOpen} headerName='Member Details Edit Update' close={() => setDialogOpen(false)}>
            <form onSubmit={handleSubmit}>
                <Grid container columnSpacing={0.5} rowSpacing={0.8}>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='mem_name'
                            label='Staff Full Name'
                            handleChange={handleChange}
                            value={values.mem_name}
                            error={typeof errors.mem_name === 'string' ? errors.mem_name : undefined}
                            handleBlur={handleBlur}
                            touched={!!touched.mem_name} // Ensure `touched` is a boolean
                            required={true}
                            placeholder='Enter Staff Full Name'
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Staff Full Name(Nepali)'
                            name='mem_name_nep'
                            value={values.mem_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'mem_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={typeof errors.mem_name_nep === 'string' ? errors.mem_name_nep : undefined}
                            placeholder='Enter Staff Full Name(nepali)'
                            touched={!!touched.mem_name_nep}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='add_eng'
                            label='Staff Address'
                            handleChange={handleChange}
                            value={values.add_eng}
                            error={typeof errors.add_eng === 'string' ? errors.add_eng : undefined}
                            handleBlur={handleBlur}
                            touched={!!touched.add_eng}
                            required={true}
                            placeholder='Enter Address'
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Address(Nepali)'
                            name='add_nep'
                            value={values.add_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'add_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={typeof errors.add_nep === 'string' ? errors.add_nep : undefined}
                            placeholder='Enter Address(nepali)'
                            touched={!!touched.add_nep}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='ward_no'
                            label='Ward No.'
                            handleChange={handleChange}
                            value={values.ward_no}
                            error={typeof errors.ward_no === 'string' ? errors.ward_no : undefined}
                            handleBlur={handleBlur}
                            touched={!!touched.ward_no}
                            required={false}
                            placeholder='Enter Ward No.'
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<MdOutlinePhone />}
                            label='SMS Mobile No.'
                            name='sms_mob_no'
                            handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'sms_mob_no' })}
                            handleBlur={handleBlur}
                            value={values.sms_mob_no}
                            error={typeof errors.sms_mob_no === 'string' ? errors.sms_mob_no : undefined}
                            touched={!!touched.sms_mob_no}
                            placeholder='XXX-XXXXXXX'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiCalendarDate />}
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'dob' })}
                            label='DOB(BS)'
                            name='dob'
                            handleBlur={handleBlur}
                            value={values.dob}
                            error={typeof errors.dob === 'string' ? errors.dob : undefined}
                            touched={!!touched.dob}
                            placeholder='XXXX/XX/XX'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Citizenship No.'
                            name='ctiz_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.ctiz_no}
                            error={typeof errors.ctiz_no === 'string' ? errors.ctiz_no : undefined}
                            touched={!!touched.ctiz_no}
                            placeholder='000-000-0'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <DefaultSelectInputBox
                            label='Gender'
                            options={GenderOptions}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            required={false}
                            placeholder='Select Gender'
                            name='gender'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'gender' } });
                            }}
                            value={values.gender}
                            touched={!!touched.gender}
                            errors={typeof errors.gender === 'string' ? errors.gender : undefined}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox type='text'
                            label='Father Name'
                            name='father_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.father_name}
                            error={typeof errors.father_name === 'string' ? errors.father_name : undefined}
                            touched={!!touched.father_name}
                            placeholder='Enter father name'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Father Name(Nepali)'
                            name='father_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'father_name_nep' })}
                            value={values.father_name_nep}
                            error={typeof errors.father_name_nep === 'string' ? errors.father_name_nep : undefined}
                            handleBlur={handleBlur}
                            placeholder='Enter father name(nepali)'
                            touched={!!touched.father_name_nep}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiCalendarDate />}
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_of_joining' })}
                            label='Date of Joinging'
                            name='date_of_joining'
                            handleBlur={handleBlur}
                            value={values.date_of_joining}
                            error={typeof errors.date_of_joining === 'string' ? errors.date_of_joining : undefined}
                            touched={!!touched.date_of_joining}
                            placeholder='XXXX/XX/XX'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiCalendarDate />}
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_of_leaving' })}
                            label='Date of Leaving'
                            name='date_of_leaving'
                            handleBlur={handleBlur}
                            value={values.date_of_leaving}
                            error={typeof errors.date_of_leaving === 'string' ? errors.date_of_leaving : undefined}
                            touched={!!touched.date_of_leaving}
                            placeholder='XXXX/XX/XX'
                            required={false}
                        />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            handleChange={handleChange}
                            label='Qualification'
                            name='qualification'
                            handleBlur={handleBlur}
                            value={values.qualification}
                            error={typeof errors.qualification === 'string' ? errors.qualification : undefined}
                            touched={!!touched.qualification}
                            placeholder='Enter Qualification'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            handleChange={handleChange}
                            label='Training'
                            name='training'
                            handleBlur={handleBlur}
                            value={values.training}
                            error={typeof errors.training === 'string' ? errors.training : undefined}
                            touched={!!touched.training}
                            placeholder='Enter training'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>

                        <InputTextBox
                            type='text'
                            handleChange={handleChange}
                            label='Language'
                            name='lang'
                            handleBlur={handleBlur}
                            value={values.lang}
                            error={typeof errors.lang === 'string' ? errors.lang : undefined}
                            touched={!!touched.lang}
                            placeholder='Enter Language'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            handleChange={handleChange}
                            label='Bank Holder Name'
                            name='bank_holder_name'
                            handleBlur={handleBlur}
                            value={values.bank_holder_name}
                            error={typeof errors.bank_holder_name === 'string' ? errors.bank_holder_name : undefined}
                            touched={!!touched.bank_holder_name}
                            placeholder='Enter Bank Holder Name'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            handleChange={handleChange}
                            label='Account Number'
                            name='acc_number'
                            handleBlur={handleBlur}
                            value={values.acc_number}
                            error={typeof errors.acc_number === 'string' ? errors.acc_number : undefined}
                            touched={!!touched.acc_number}
                            placeholder='Enter Account Number'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            handleChange={handleChange}
                            label='Bank Name'
                            name='bank_name'
                            handleBlur={handleBlur}
                            value={values.bank_name}
                            error={typeof errors.bank_name === 'string' ? errors.bank_name : undefined}
                            touched={!!touched.bank_name}
                            placeholder='Enter Bank Name'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            handleChange={handleChange}
                            label='Branch Name'
                            name='branch_name'
                            handleBlur={handleBlur}
                            value={values.branch_name}
                            error={typeof errors.branch_name === 'string' ? errors.branch_name : undefined}
                            touched={!!touched.branch_name}
                            placeholder='Enter Branch Name'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            handleChange={handleChange}
                            label='Bank Code'
                            name='bank_code'
                            handleBlur={handleBlur}
                            value={values.bank_code}
                            error={typeof errors.bank_code === 'string' ? errors.bank_code : undefined}
                            touched={!!touched.bank_code}
                            placeholder='Enter Bank Code'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='Initial Salary'
                            name='initial_salary'
                            handleBlur={handleBlur}
                            value={values.initial_salary}
                            error={typeof errors.initial_salary === 'string' ? errors.initial_salary : undefined}
                            touched={!!touched.initial_salary}
                            placeholder='000'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='Grade Count'
                            name='grade_count'
                            handleBlur={handleBlur}
                            value={values.grade_count}
                            error={typeof errors.grade_count === 'string' ? errors.grade_count : undefined}
                            touched={!!touched.grade_count}
                            placeholder='0'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='Grade Amount'
                            name='grade_amt'
                            handleBlur={handleBlur}
                            value={values.grade_amt}
                            error={typeof errors.grade_amt === 'string' ? errors.grade_amt : undefined}

                            touched={!!touched.grade_amt}
                            placeholder='0'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='Allowance'
                            name='allowance'
                            handleBlur={handleBlur}
                            value={values.allowance}
                            error={typeof errors.allowance === 'string' ? errors.allowance : undefined}
                            touched={!!touched.allowance}
                            placeholder='0.00'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='Tax Amount'
                            name='tax_amount'
                            handleBlur={handleBlur}
                            value={values.tax_amount}
                            error={typeof errors.tax_amount === 'string' ? errors.tax_amount : undefined}
                            touched={!!touched.tax_amount}
                            placeholder='0.00'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='PF Amount'
                            name='pf_amount'
                            handleBlur={handleBlur}
                            value={values.pf_amount}
                            error={typeof errors.pf_amount === 'string' ? errors.pf_amount : undefined}
                            touched={!!touched.pf_amount}
                            placeholder='0.00'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='PF Thap Amount'
                            name='pf_thap_amt'
                            handleBlur={handleBlur}
                            value={values.pf_thap_amt}
                            error={typeof errors.pf_thap_amt === 'string' ? errors.pf_thap_amt : undefined}

                            touched={!!touched.pf_thap_amt}
                            placeholder='0.00'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='Sa. Su. Tax'
                            name='ss_tax'
                            handleBlur={handleBlur}
                            value={values.ss_tax}
                            error={typeof errors.ss_tax === 'string' ? errors.ss_tax : undefined}
                            touched={!!touched.ss_tax}
                            placeholder='0.00'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='Insurance'
                            name='insurance'
                            handleBlur={handleBlur}
                            value={values.insurance}
                            error={typeof errors.insurance === 'string' ? errors.insurance : undefined}
                            touched={!!touched.insurance}
                            placeholder='0.00'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='number'
                            handleChange={handleChange}
                            label='Insurance'
                            name='ss_found'
                            handleBlur={handleBlur}
                            value={values.ss_found}
                            error={typeof errors.ss_found === 'string' ? errors.ss_found : undefined}

                            touched={!!touched.ss_found}
                            placeholder='0.00'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Photo'
                            name='photo'
                            handleBlur={handleBlur}
                            // ref={(el) => (fileInputRefs.current['photo'] = el)}
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("photo", file); // Handle the file change correctly
                                }
                            }}
                            
                            required={false} />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='remarks'
                            label='Remarks'
                            handleChange={handleChange}
                            value={values.remarks}
                            error={typeof errors.remarks === 'string' ? errors.remarks : undefined}
                            handleBlur={handleBlur}
                            touched={!!touched.remarks}
                            required={false}
                            placeholder='Enter Remarks'
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={6} xs={12}>
                        <DefaultSelectInputBox
                            label="Active"
                            options={YesNoOptions}
                            name='status'
                            required={true}
                            placeholder='Select status'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.status}
                            touched={!!touched.status}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </DialogBox>
    )
}

export default PayrollStaffEditView


